import { render } from "./DashboardViews.vue?vue&type=template&id=0cdc6fea&scoped=true"
import script from "./DashboardViews.vue?vue&type=script&lang=js"
export * from "./DashboardViews.vue?vue&type=script&lang=js"

import "./DashboardViews.vue?vue&type=style&index=0&id=0cdc6fea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cdc6fea"]])

export default __exports__